(() => {
  const formatMoney = (cents, currency) => {
    if (window.Shopify?.formatMoney && window.Shopify?.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format(Number(cents) / 100);
    } catch {
      return `${(Number(cents) / 100).toFixed(2)} ${currency}`;
    }
  };

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-step]');
      if (!button || !input) return;
      const min = Number(input.min) || 1;
      const step = Number(input.step) || 1;
      input.value = String(Math.max(min, (Number(input.value) || min) + Number(button.dataset.quantityStep) * step));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-autodesk-education-picker]').forEach((picker) => {
    const form = picker.closest('form');
    const variantInput = form?.querySelector('[data-autodesk-education-variant-id]');
    const price = document.querySelector('[data-autodesk-price]');
    const addButton = form?.querySelector('button[name="add"]');
    const yearPicker = form?.querySelector('[data-autodesk-education-years]');
    const gallery = document.querySelector('[data-autodesk-gallery]');
    const intro = document.querySelector('.rdr21-product-intro');
    if (!form || !variantInput || !yearPicker || !window.Rdr21ProductSelection) return;

    const selection = window.Rdr21ProductSelection;
    const state = selection.guard(form, variantInput);
    const currency = price?.querySelector('small')?.textContent?.trim() || 'EUR';
    const durationButtons = [...picker.querySelectorAll('[data-autodesk-duration-choice]')];
    const durationButton = (duration) => durationButtons.find((button) => button.dataset.duration === String(duration));
    let selectedDuration = picker.dataset.selectedDuration === '3' ? '3' : '1';
    let currentProduct = { id: form.querySelector('input[name="product-id"]')?.value || '' };
    let loadSequence = 0;

    const numericId = (value) => /^\d+$/.test(String(value || '')) && Number(value) > 0;
    const priceCents = (value) => Number.parseInt(value, 10);
    const isValidEducationVariant = (variant, duration, expected = {}) => {
      if (!variant || !numericId(variant.id) || String(variant.id) !== String(expected.id || variant.id)) return false;
      const title = String(variant.title || '').trim();
      const sku = String(variant.sku || '').trim().toUpperCase();
      const priceValue = Number(variant.price);
      if (!Number.isFinite(priceValue) || priceValue <= 0) return false;
      if (expected.price !== '' && expected.price !== undefined && priceValue !== priceCents(expected.price)) return false;
      if (String(duration) === '3') {
        return expected.enabled === true
          && title === 'Education Account-Zuweisung | 3 Jahre'
          && /-EDU-3Y$/.test(sku)
          && priceValue === 7999
          && Number(variant.compare_at_price || 0) === 9999
          && (expected.compare === '' || expected.compare === undefined || Number(variant.compare_at_price || 0) === priceCents(expected.compare));
      }
      return title === 'Education Account-Zuweisung'
        && /-EDU$/.test(sku)
        && !/-EDU-3Y$/.test(sku)
        && (!expected.compare || Number(variant.compare_at_price || 0) === priceCents(expected.compare));
    };
    const variantFromButton = (button) => {
      if (!button || !numericId(button.dataset.variantId)) return null;
      const variant = {
        id: button.dataset.variantId,
        title: button.dataset.title || '',
        sku: button.dataset.sku || '',
        price: priceCents(button.dataset.priceCents),
        compare_at_price: priceCents(button.dataset.compareCents || '0'),
        available: button.dataset.available === 'true',
      };
      return isValidEducationVariant(variant, button.dataset.duration, {
        id: button.dataset.variantId,
        price: button.dataset.priceCents,
        compare: button.dataset.compareCents,
        enabled: picker.dataset.education3yEnabled === 'true',
      }) ? variant : null;
    };
    const format = (cents) => formatMoney(cents, currency);
    const updatePrice = (variant) => {
      const current = price?.querySelector('[data-price-current]');
      const compare = price?.querySelector('[data-price-compare]');
      const saleDeadline = document.querySelector('[data-sale-deadline]');
      const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
      if (current) current.textContent = format(variant.price);
      if (compare) {
        compare.textContent = hasCompare ? format(variant.compare_at_price) : '';
        compare.hidden = !hasCompare;
      }
      if (saleDeadline) saleDeadline.hidden = !hasCompare;
    };
    const updateDurationButtons = (link, product) => {
      let selectedVariant = null;
      durationButtons.forEach((button) => {
        const duration = button.dataset.duration;
        const id = link.dataset[`education${duration}yVariant`];
        const variant = product.variants?.find((item) => String(item.id) === String(id));
        const expected = {
          id,
          price: link.dataset[`education${duration}yPriceCents`],
          compare: link.dataset[`education${duration}yCompareCents`],
          enabled: duration !== '3' || link.dataset.education3yEnabled === 'true',
        };
        const valid = numericId(id) && isValidEducationVariant(variant, duration, expected);
        button.disabled = !valid || !variant.available;
        button.classList.toggle('is-disabled', !valid || !variant.available);
        button.setAttribute('aria-disabled', String(!valid || !variant.available));
        button.dataset.variantId = valid ? String(variant.id) : '';
        button.dataset.title = valid ? variant.title : '';
        button.dataset.sku = valid ? variant.sku : '';
        button.dataset.priceCents = valid ? String(variant.price) : '';
        button.dataset.compareCents = valid ? String(variant.compare_at_price || 0) : '';
        button.dataset.available = valid ? String(Boolean(variant.available)) : 'false';
        const label = button.querySelector('small');
        if (label) label.textContent = valid ? format(variant.price) : picker.dataset.unavailableLabel || label.textContent;
        if (duration === selectedDuration && valid && variant.available) selectedVariant = variant;
        button.classList.toggle('is-selected', duration === selectedDuration && valid);
        button.setAttribute('aria-pressed', String(duration === selectedDuration && valid));
      });
      return selectedVariant;
    };
    const updateYearLinks = () => {
      yearPicker.dataset.duration = selectedDuration;
      yearPicker.querySelectorAll('a[data-product-handle]').forEach((link) => {
        const id = link.dataset[`education${selectedDuration}yVariant`];
        const formattedPrice = link.dataset[`education${selectedDuration}yPrice`];
        const resolved = link.dataset.educationResolved === 'true';
        const enabled = resolved && numericId(id) && link.dataset[`education${selectedDuration}yAvailable`] === 'true';
        link.classList.toggle('is-disabled', !enabled);
        if (enabled) {
          link.href = selection.url(link.dataset.productUrl, id);
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
          const label = link.querySelector('small');
          if (label && formattedPrice) label.textContent = formattedPrice;
        } else {
          link.href = link.dataset.productUrl;
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('tabindex', '-1');
          const label = link.querySelector('small');
          if (label) label.textContent = resolved ? (link.dataset.unavailableLabel || yearPicker.dataset.unavailableLabel || '') : '…';
        }
      });
    };
    const mapEducationVariant = (link, duration, sourceButton, enabled3y) => {
      const id = sourceButton?.dataset.variantId || '';
      const variant = sourceButton ? {
        id,
        title: sourceButton.dataset.title || '',
        sku: sourceButton.dataset.sku || '',
        price: priceCents(sourceButton.dataset.priceCents),
        compare_at_price: priceCents(sourceButton.dataset.compareCents || '0'),
        available: sourceButton.dataset.available === 'true',
      } : null;
      const valid = isValidEducationVariant(variant, duration, {
        id,
        price: sourceButton?.dataset.priceCents,
        compare: sourceButton?.dataset.compareCents,
        enabled: String(duration) !== '3' || enabled3y,
      });
      const prefix = `education${duration}y`;
      link.dataset[`${prefix}Variant`] = valid ? String(variant.id) : '';
      link.dataset[`${prefix}Available`] = valid ? String(Boolean(variant.available)) : 'false';
      link.dataset[`${prefix}Price`] = valid ? sourceButton.querySelector('small')?.textContent?.trim() || format(variant.price) : '';
      link.dataset[`${prefix}PriceCents`] = valid ? String(variant.price) : '';
      link.dataset[`${prefix}CompareCents`] = valid ? String(variant.compare_at_price || 0) : '';
      link.dataset[`${prefix}Title`] = valid ? variant.title : '';
      link.dataset[`${prefix}Sku`] = valid ? variant.sku : '';
    };
    const resolveYearLinks = async () => {
      const sectionId = yearPicker.dataset.productSectionId;
      const links = [...yearPicker.querySelectorAll('a[data-product-handle]')];
      await Promise.all(links.map(async (link) => {
        if (link.dataset.educationResolved === 'true') return;
        try {
          if (!sectionId) throw new Error('Product section ID is missing.');
          const response = await fetch(`${link.dataset.productUrl}?sections=${sectionId}`, { headers: { Accept: '*/*' }, signal: AbortSignal.timeout(12000) });
          if (!response.ok) throw new Error('Could not load this Autodesk version.');
          const sections = await response.json();
          const html = sections?.[sectionId];
          if (typeof html !== 'string') throw new Error('Autodesk product section missing.');
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const remotePicker = parsed.querySelector('[data-autodesk-education-picker]');
          if (!remotePicker || remotePicker.dataset.educationProductHandle !== link.dataset.productHandle) throw new Error('Unexpected Autodesk product.');
          const buttons = [...remotePicker.querySelectorAll('[data-autodesk-duration-choice]')];
          link.dataset.education3yEnabled = String(remotePicker.dataset.education3yEnabled === 'true');
          mapEducationVariant(link, '1', buttons.find((button) => button.dataset.duration === '1'), remotePicker.dataset.education3yEnabled === 'true');
          mapEducationVariant(link, '3', buttons.find((button) => button.dataset.duration === '3'), remotePicker.dataset.education3yEnabled === 'true');
        } catch (error) {
          link.dataset.education1yVariant = '';
          link.dataset.education1yAvailable = 'false';
          link.dataset.education3yVariant = '';
          link.dataset.education3yAvailable = 'false';
          console.warn('RDR Autodesk Education year lookup failed:', error.message);
        } finally {
          link.dataset.educationResolved = 'true';
          updateYearLinks();
        }
      }));
    };
    const renderGallery = (product) => {
      if (!gallery || !Array.isArray(product.images) || !product.images.length) return;
      gallery.replaceChildren(...product.images.map((src, index) => {
        const image = document.createElement('img');
        image.src = src;
        image.alt = product.title || '';
        image.width = 1200;
        image.loading = index === 0 ? 'eager' : 'lazy';
        return image;
      }));
    };
    const renderDescription = (html) => {
      const description = document.querySelector('[data-autodesk-description]');
      if (!description) return;
      const parsed = new DOMParser().parseFromString(String(html || ''), 'text/html');
      parsed.querySelectorAll('script').forEach((node) => node.remove());
      parsed.querySelectorAll('*').forEach((node) => {
        [...node.attributes].filter((attribute) => /^on/i.test(attribute.name)).forEach((attribute) => node.removeAttribute(attribute.name));
      });
      description.replaceChildren(...[...parsed.body.childNodes].map((node) => document.importNode(node, true)));
    };
    const commitDuration = async (duration, variant, { historyMode = 'replace', product = currentProduct, productUrl = window.location.pathname } = {}) => {
      if (!variant || !isValidEducationVariant(variant, duration, { id: variant.id, enabled: duration !== '3' || picker.dataset.education3yEnabled === 'true' })) {
        state.block();
        return false;
      }
      selectedDuration = String(duration);
      picker.dataset.selectedDuration = selectedDuration;
      durationButtons.forEach((button) => {
        const selected = button.dataset.duration === selectedDuration;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      updatePrice(variant);
      if (!state.commit(variant, product)) return false;
      currentProduct = product;
      updateYearLinks();
      const url = selection.url(productUrl, variant.id);
      if (historyMode === 'push') window.history.pushState({ rdr21AutodeskEducation: true }, '', url);
      if (historyMode === 'replace') window.history.replaceState({ rdr21AutodeskEducation: true }, '', url);
      await state.refreshPaymentButton(productUrl, product, variant);
      return true;
    };
    const initialButton = durationButton(selectedDuration);
    const fallbackButton = durationButton('1') || durationButton('3');
    const chosenButton = variantFromButton(initialButton) && !initialButton.disabled ? initialButton : fallbackButton;
    const initialVariant = variantFromButton(chosenButton);
    if (initialVariant && !chosenButton.disabled) {
      selectedDuration = chosenButton.dataset.duration;
      currentProduct = { id: form.querySelector('input[name="product-id"]')?.value || '' };
      state.commit(initialVariant, currentProduct);
      updatePrice(initialVariant);
      picker.dataset.selectedDuration = selectedDuration;
    } else {
      state.block();
    }
    const currentYearLink = yearPicker.querySelector('a[aria-current="true"]');
    if (currentYearLink) {
      const currentHas3y = picker.dataset.education3yEnabled === 'true';
      currentYearLink.dataset.education3yEnabled = String(currentHas3y);
      mapEducationVariant(currentYearLink, '1', durationButton('1'), currentHas3y);
      mapEducationVariant(currentYearLink, '3', durationButton('3'), currentHas3y);
    }
    updateYearLinks();
    resolveYearLinks();

    picker.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-autodesk-duration-choice]');
      if (!button || button.disabled) return;
      const variant = variantFromButton(button);
      if (!variant || !variant.available) { state.block(); return; }
      try {
        await commitDuration(button.dataset.duration, variant);
      } catch (error) {
        state.block();
        console.warn('RDR Autodesk Education duration update failed:', error.message);
      }
    });

    const loadYear = async (link, { historyMode = 'push', requestedDuration } = {}) => {
      const sequence = ++loadSequence;
      const nextDuration = String(requestedDuration || selectedDuration);
      const expectedId = link.dataset[`education${nextDuration}yVariant`];
      if (!numericId(expectedId)) { state.block(); return; }
      state.busy(true);
      try {
        const response = await fetch(link.dataset.productJsonUrl, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(12000) });
        if (!response.ok) throw new Error('Could not load this Autodesk version.');
        const product = await response.json();
        if (sequence !== loadSequence) return;
        if (product.handle !== link.dataset.productHandle) throw new Error('Unexpected Autodesk product.');
        const variant = product.variants?.find((item) => String(item.id) === String(expectedId));
        const expected = {
          id: expectedId,
          price: link.dataset[`education${nextDuration}yPriceCents`],
          compare: link.dataset[`education${nextDuration}yCompareCents`],
          enabled: nextDuration !== '3' || link.dataset.education3yEnabled === 'true',
        };
        if (!isValidEducationVariant(variant, nextDuration, expected)) throw new Error('Education duration mapping failed validation.');
        selectedDuration = nextDuration;
        const mappedVariant = updateDurationButtons(link, product);
        if (!mappedVariant || String(mappedVariant.id) !== String(variant.id)) throw new Error('Selected Education variant is unavailable.');
        if (!state.commit(variant, product)) throw new Error('Invalid Autodesk variant data.');
        currentProduct = product;
        updatePrice(variant);
        updateYearLinks();
        await state.refreshPaymentButton(link.dataset.productUrl, product, variant);
        if (sequence !== loadSequence) return;
        renderGallery(product);
        if (intro) {
          intro.textContent = String(link.dataset.productSummary || '').trim();
          intro.hidden = !intro.textContent;
        }
        renderDescription(product.description);
        const title = link.dataset.productTitle || product.title || '';
        document.querySelectorAll('[data-autodesk-title]').forEach((node) => { node.textContent = title; });
        yearPicker.querySelectorAll('a[data-product-handle]').forEach((item) => {
          const selected = item === link;
          item.classList.toggle('is-selected', selected);
          if (selected) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        const url = selection.url(link.dataset.productUrl, variant.id);
        if (historyMode === 'push') window.history.pushState({ rdr21AutodeskEducation: true }, '', url);
        if (historyMode === 'replace') window.history.replaceState({ rdr21AutodeskEducation: true }, '', url);
        link.dataset.productJsonUrl = `${link.dataset.productUrl}.js`;
        if (product.title) document.title = `${title} | ${document.title.split(' | ').slice(1).join(' | ') || 'RDR Software'}`;
      } catch (error) {
        if (sequence !== loadSequence) return;
        state.block();
        throw error;
      } finally {
        if (sequence === loadSequence) state.busy(false);
      }
    };

    yearPicker.addEventListener('click', async (event) => {
      const link = event.target.closest('a[data-product-handle]');
      if (!link) return;
      if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      try { await loadYear(link); }
      catch (error) { window.location.assign(link.href); }
    });

    window.addEventListener('popstate', () => {
      const path = window.location.pathname.replace(/\/$/, '');
      const link = [...yearPicker.querySelectorAll('a[data-product-handle]')].find((item) => new URL(item.dataset.productUrl, window.location.origin).pathname.replace(/\/$/, '') === path);
      if (!link) { window.location.reload(); return; }
      const requestedVariant = new URL(window.location.href).searchParams.get('variant');
      const requestedDuration = String(link.dataset.education1yVariant) === requestedVariant ? '1' : (String(link.dataset.education3yVariant) === requestedVariant ? '3' : '');
      if (!requestedDuration) { window.location.reload(); return; }
      loadYear(link, { historyMode: 'none', requestedDuration }).catch(() => window.location.reload());
    });
  });

  document.querySelectorAll('[data-autodesk-picker]').forEach((picker) => {
    const form = picker.closest('form');
    if (!form) return;
    const variantInput = form.querySelector('[data-autodesk-variant-id]');
    const price = document.querySelector('[data-autodesk-price]');
    const addButton = form.querySelector('button[name="add"]');
    const yearPicker = form.querySelector('[data-autodesk-years]');
    const gallery = document.querySelector('[data-autodesk-gallery]');
    const intro = document.querySelector('.rdr21-product-intro');
    const currency = price?.querySelector('small')?.textContent?.trim() || 'EUR';
    if (!variantInput || !window.Rdr21ProductSelection) return;
    const selection = window.Rdr21ProductSelection;
    const state = selection.guard(form, variantInput);
    let loadSequence = 0;
    let selectedEdition = picker.querySelector('input[type="radio"]:checked')?.dataset.edition || 'standard';
    let variantMap = Object.fromEntries([...picker.querySelectorAll('input[type="radio"]')].map((input) => [input.dataset.edition, {
      id: Number(input.value),
      price: Number(input.dataset.priceCents || 0),
      compare_at_price: Number(input.dataset.compareCents || 0),
      available: input.dataset.available === 'true',
      title: input.dataset.edition,
    }]));

    const editionForVariant = (variant) => {
      const title = variant?.title || '';
      const sku = variant?.sku || '';
      if (/education/i.test(title) || /-EDU$/i.test(sku)) return 'education';
      if (/standard/i.test(title) || /-INV$/i.test(sku)) return 'standard';
      return null;
    };
    const variantForEdition = (product, edition) => product.variants?.find((variant) => editionForVariant(variant) === edition) || null;
    const updateYearLinks = (edition) => {
      yearPicker?.querySelectorAll('[data-product-handle]').forEach((link) => {
        const variantId = link.dataset[`${edition}Variant`];
        const formattedPrice = link.dataset[`${edition}Price`];
        if (variantId) {
          link.href = selection.url(link.dataset.productUrl, variantId);
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
          link.classList.remove('is-disabled');
        } else {
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('tabindex', '-1');
          link.classList.add('is-disabled');
          const unavailableLabel = link.querySelector('small');
          if (unavailableLabel) unavailableLabel.textContent = link.dataset.unavailableLabel || unavailableLabel.textContent;
        }
        const priceLabel = link.querySelector('small');
        if (variantId && priceLabel && formattedPrice) priceLabel.textContent = formattedPrice;
      });
    };

    const renderGallery = (product) => {
      if (!gallery || !Array.isArray(product.images) || !product.images.length) return;
      gallery.replaceChildren(...product.images.map((src, index) => {
        const image = document.createElement('img');
        image.src = src;
        image.alt = product.title || '';
        image.width = 1200;
        image.loading = index === 0 ? 'eager' : 'lazy';
        return image;
      }));
    };

    const renderIntro = (summary) => {
      if (!intro) return;
      const text = String(summary || '').trim();
      intro.textContent = text;
      intro.hidden = !text;
    };

    const renderDescription = (html) => {
      const description = document.querySelector('[data-autodesk-description]');
      if (!description) return;
      const parsed = new DOMParser().parseFromString(String(html || ''), 'text/html');
      parsed.querySelectorAll('script').forEach((node) => node.remove());
      parsed.querySelectorAll('*').forEach((node) => {
        [...node.attributes].filter((attribute) => /^on/i.test(attribute.name)).forEach((attribute) => node.removeAttribute(attribute.name));
      });
      description.replaceChildren(...[...parsed.body.childNodes].map((node) => document.importNode(node, true)));
    };

    const syncVariant = (variant, edition = selectedEdition) => {
      if (!variant || !variantInput || !Number.isFinite(Number(variant.id)) || !Number.isFinite(Number(variant.price))) return false;
      selectedEdition = edition;
      variantMap[edition] = variant;
      variantInput.value = variant.id;
      picker.querySelectorAll('input[type="radio"]').forEach((input) => {
        const isSelected = input.dataset.edition === selectedEdition;
        input.checked = isSelected;
        const currentVariant = variantMap[input.dataset.edition];
        if (isSelected) {
          input.value = String(variant.id);
          input.dataset.price = formatMoney(variant.price, currency);
          input.dataset.priceCents = String(variant.price);
          input.dataset.comparePrice = Number(variant.compare_at_price) > Number(variant.price) ? formatMoney(variant.compare_at_price, currency) : '';
          input.dataset.compareCents = String(variant.compare_at_price || 0);
          input.dataset.available = String(Boolean(variant.available));
          const optionPrice = input.closest('[data-autodesk-option]')?.querySelector('.rdr21-autodesk-option__price');
          const optionAvailability = input.closest('[data-autodesk-option]')?.querySelector('small');
          if (optionPrice) optionPrice.textContent = formatMoney(variant.price, currency);
          if (optionAvailability) optionAvailability.textContent = variant.available ? optionAvailability.dataset.availableLabel : optionAvailability.dataset.soldOutLabel;
        } else if (currentVariant) {
          input.value = String(currentVariant.id);
          input.dataset.price = formatMoney(currentVariant.price, currency);
          input.dataset.priceCents = String(currentVariant.price);
          input.dataset.comparePrice = Number(currentVariant.compare_at_price) > Number(currentVariant.price) ? formatMoney(currentVariant.compare_at_price, currency) : '';
          input.dataset.compareCents = String(currentVariant.compare_at_price || 0);
          input.dataset.available = String(Boolean(currentVariant.available));
        }
        const optionAvailability = input.closest('[data-autodesk-option]')?.querySelector('small');
        if (optionAvailability) optionAvailability.textContent = input.dataset.available === 'true' ? optionAvailability.dataset.availableLabel : optionAvailability.dataset.soldOutLabel;
        input.disabled = !currentVariant || !Boolean((isSelected ? variant : currentVariant)?.available);
        input.closest('[data-autodesk-option]')?.classList.toggle('is-selected', isSelected);
      });
      const currentPrice = price?.querySelector('[data-price-current]');
      const comparePrice = price?.querySelector('[data-price-compare]');
      const saleDeadline = document.querySelector('[data-sale-deadline]');
      const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
      if (currentPrice) currentPrice.textContent = formatMoney(variant.price, currency);
      if (comparePrice) {
        comparePrice.textContent = hasCompare ? formatMoney(variant.compare_at_price, currency) : '';
        comparePrice.hidden = !hasCompare;
      }
      if (saleDeadline) saleDeadline.hidden = !hasCompare;
      if (!state.commit(variant)) return false;
      updateYearLinks(selectedEdition);
      return true;
    };

    const loadYear = async (link, { historyMode = 'push', requestedEdition } = {}) => {
      const sequence = ++loadSequence;
      state.busy(true);
      try {
        if (requestedEdition) selectedEdition = requestedEdition;
        const response = await fetch(link.dataset.productJsonUrl, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(12000) });
        if (!response.ok) throw new Error('Could not load this Autodesk version.');
        const product = await response.json();
        if (sequence !== loadSequence) return;
        if (product.handle !== link.dataset.productHandle) throw new Error('Unexpected Autodesk product.');
        const edition = selectedEdition;
        const variant = variantForEdition(product, edition);
        if (!variant) {
          state.block();
          const missingEditionError = new Error('This Autodesk product does not contain the selected license type.');
          missingEditionError.variantMissing = true;
          throw missingEditionError;
        }
        variantMap = Object.fromEntries((product.variants || []).map((item) => [editionForVariant(item), item]).filter(([key]) => key));
        if (!syncVariant(variant, edition)) throw new Error('This Autodesk variant data is invalid.');
        if (!state.commit(variant, product)) throw new Error('Invalid Autodesk variant data.');
        await state.refreshPaymentButton(link.dataset.productUrl, product, variant);
        if (sequence !== loadSequence) return;
        renderGallery(product);
        renderIntro(link.dataset.productSummary);
        renderDescription(product.description);
        const title = link.dataset.productTitle || product.title || '';
        document.querySelectorAll('[data-autodesk-title]').forEach((node) => { node.textContent = title; });
        yearPicker.querySelectorAll('[data-product-handle]').forEach((item) => {
          const selected = item === link;
          item.classList.toggle('is-selected', selected);
          if (selected) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        const url = selection.url(link.dataset.productUrl, variant.id);
        if (historyMode === 'push') window.history.pushState({ rdr21Autodesk: true }, '', url);
        if (historyMode === 'replace') window.history.replaceState({ rdr21Autodesk: true }, '', url);
        link.dataset.productJsonUrl = `${link.dataset.productUrl}.js`;
        if (product.title) document.title = `${title} | ${document.title.split(' | ').slice(1).join(' | ') || 'RDR Software'}`;
      } catch (error) {
        if (sequence !== loadSequence) return;
        state.block();
        throw error;
      } finally {
        if (sequence === loadSequence) state.busy(false);
      }
    };

    picker.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        selectedEdition = input.dataset.edition;
        const variant = variantMap[selectedEdition];
        if (!variant || !syncVariant(variant, selectedEdition)) {
          state.block();
          return;
        }
        const selectedYear = yearPicker?.querySelector('[aria-current="true"]');
        const yearUrl = selection.url(selectedYear?.dataset.productUrl || window.location.pathname, variant.id);
        if (selectedYear) selectedYear.href = yearUrl;
        window.history.replaceState({ rdr21Autodesk: true }, '', yearUrl);
      });
    });

    yearPicker?.addEventListener('click', async (event) => {
      const link = event.target.closest('a[data-product-handle]');
      if (!link) return;
      if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      try {
        await loadYear(link);
      } catch (error) {
        if (error.variantMissing) return;
        window.location.assign(link.href);
      }
    });

    window.addEventListener('popstate', () => {
      const path = window.location.pathname.replace(/\/$/, '');
      const link = [...(yearPicker?.querySelectorAll('a[data-product-handle]') || [])].find((item) => new URL(item.dataset.productUrl, window.location.origin).pathname.replace(/\/$/, '') === path);
      if (!link) { window.location.reload(); return; }
      const requestedVariant = new URL(window.location.href).searchParams.get('variant');
      const requestedEdition = String(link.dataset.educationVariant) === requestedVariant ? 'education' : 'standard';
      loadYear(link, { historyMode: 'none', requestedEdition }).catch(() => window.location.reload());
    });
    updateYearLinks(selectedEdition);
  });
})();
